import {
    CordedBlindsSVGPath,
    ElectricalSVGPath,
    GasSVGPath,
    MinimumStandardsSVGPath,
    MiniumEnergyEfficiencyStandardReadinessCheckSVGPath,
    OtherServiceSVGPath,
    SafetySwitchSVGPath,
    SmokeSVGPath,
    WaterEfficiencySVGPath,
} from './service-svg-paths';

function getPath(service: string): React.ReactNode {
    if (service.toLowerCase().includes('smoke')) {
        return <SmokeSVGPath />;
    }

    if (service.toLowerCase().includes('gas')) {
        return <GasSVGPath />;
    }

    if (service.toLowerCase().includes('elec')) {
        return <ElectricalSVGPath />;
    }

    if (service.toLowerCase().includes('water')) {
        return <WaterEfficiencySVGPath />;
    }

    if (service.toLowerCase().includes('rcd')) {
        return <SafetySwitchSVGPath />;
    }

    if (service.toLowerCase().includes('blinds')) {
        return <CordedBlindsSVGPath />;
    }

    if (service.toLowerCase().includes('minimum')) {
        return <MinimumStandardsSVGPath />;
    }

    if (service.toLowerCase().includes('mees')) {
        return <MiniumEnergyEfficiencyStandardReadinessCheckSVGPath />;
    }

    return <OtherServiceSVGPath />;
}

export function ServiceIcon({
    height = '100%',
    fill = 'currentColor',
    service,
}: {
    height?: string;
    fill?: string;
    service: string;
}) {
    if (service === undefined) {
        return null;
    }

    return (
        <svg
            height={height}
            stroke={fill}
            fill={fill}
            strokeWidth={2}
            overflow="visible"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            xmlSpace="preserve"
        >
            { getPath(service) }
        </svg>
    );
}
